/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Sports_Science18Inputs */

const en__field_enum_study_sports_science18 = /** @type {(inputs: _Field_Enum_Study_Sports_Science18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sports Science`)
};

const de__field_enum_study_sports_science18 = /** @type {(inputs: _Field_Enum_Study_Sports_Science18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sportwissenschaft`)
};

/**
* | output |
* | --- |
* | "Sports Science" |
*
* @param {_Field_Enum_Study_Sports_Science18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_sports_science18 = /** @type {((inputs?: _Field_Enum_Study_Sports_Science18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Sports_Science18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_sports_science18(inputs)
	return de__field_enum_study_sports_science18(inputs)
});
export { _field_enum_study_sports_science18 as "_field_enum_STUDY_SPORTS_SCIENCE" }